import { useDialog } from '@dni-hooks/useDialog'
import { Button } from '@pets-ui/Button/Button'
import { Dialog } from '@pets-ui/Dialog/Dialog'
import { DialogActions } from '@pets-ui/DialogActions/DialogActions'
import { DialogContent } from '@pets-ui/DialogContent/DialogContent'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'

export const DIALOG_READY_FOR_SHIPMENT_CANNOT_CANCEL = 'DIALOG_READY_FOR_SHIPMENT_CANNOT_CANCEL'

export interface DialogReadyForShipmentCannotCancelExtraProps {
  isMerchant: boolean
}

export function DialogReadyForShipmentCannotCancel() {
  const { open, closeDialog, isMerchant } = useDialog<DialogReadyForShipmentCannotCancelExtraProps>(DIALOG_READY_FOR_SHIPMENT_CANNOT_CANCEL)

  const content = isMerchant
    ? '商品正在進行包裝，此階段已無法取消訂單，如需協助請聯繫業務處理。'
    : '商品正在進行包裝，此階段已無法取消訂單。'

  return (
    <Dialog onClose={closeDialog} open={open} maxWidth={320} fullWidth>
      <DialogHeader align="center" title="商品準備出貨，無法取消訂單" />
      <DialogContent>
        <Text color={colors.grey800}>{content}</Text>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialog} variant="filled" color="primary" fullWidth>確認</Button>
      </DialogActions>
    </Dialog>
  )
}
